import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { applyClasses, applyProps } from '../shared/js';
import styles from './separator.module.scss';

const Separator = (props) => (
  <div
    className={cn(
      styles.separator,
      // eslint-disable-next-line react/prop-types
      props.className,
      applyClasses(props, styles)
    )}
    {...applyProps(props)}
  />
);

Separator.propTypes = {
  /** Creates a horizontal separator */
  horizontal: PropTypes.bool,
  /** Creates a vertical separator */
  vertical: PropTypes.bool,
  /** Creates a narrow separator */
  narrow: PropTypes.bool,
  /** Creates a normal separator */
  normal: PropTypes.bool,
  /** Creates a wide separator */
  wide: PropTypes.bool,
  /** Creates a gray separator */
  gray: PropTypes.bool,
  /** Creates a dark gray separator */
  darkGray: PropTypes.bool,
  /** Creates a black separator */
  black: PropTypes.bool,
};

Separator.defaultProps = {
  horizontal: false,
  vertical: false,
  narrow: false,
  normal: false,
  wide: false,
  gray: false,
  darkGray: false,
  black: false,
};

export default Separator;
